var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.nomeProfissional))])]), _c('v-col', [_c('div', {
    staticClass: "text-body-2 text-grey-darken-1 mt-1"
  }, [_vm._v(" Função no Programa: " + _vm._s(_vm.profissional.funcao) + " ")])]), _c('v-col', [_c('div', {
    staticClass: "text-body-2 text-grey-darken-1 mt-1"
  }, [_vm._v(" E-mail: " + _vm._s(_vm.profissional.email) + " ")])]), _c('v-col', [_c('div', {
    staticClass: "text-body-2 text-grey-darken-1 mt-1"
  }, [_vm._v(" Componente Curricular: " + _vm._s(_vm.profissional.componenteCurricular) + " ")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }